import { faSpinner, faUser } from '@fortawesome/free-solid-svg-icons';

export class IconHelper {
	static readonly Icons = {
		Spinner: faSpinner,
		User: faUser
	};
}
